import { render, staticRenderFns } from "./yidui.vue?vue&type=template&id=721f6648&scoped=true&"
import script from "./yidui.vue?vue&type=script&lang=js&"
export * from "./yidui.vue?vue&type=script&lang=js&"
import style0 from "./yidui.vue?vue&type=style&index=0&id=721f6648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721f6648",
  null
  
)

export default component.exports